export const SET_HRES96U_INDEX_DISP = 'SET_HRES96U_INDEX_DISP'
export const GET_HRES96U_INDEX_DISP = 'GET_HRES96U_INDEX_DISP'
export const SET_HRES96U_DETAIL_DISP = 'SET_HRES96U_DETAIL_DISP'
export const GET_HRES96U_DETAIL_DISP = 'GET_HRES96U_DETAIL_DISP'
export const GET_HRES96U_MAX_ROWSPAN = 'GET_HRES96U_MAX_ROWSPAN'
export const SET_HRES96U_COLUMNS = 'SET_HRES96U_COLUMNS'
export const GET_HRES96U_COLUMNS = 'GET_HRES96U_COLUMNS'
export const SET_HRES96U_LABELS = 'SET_HRES96U_LABELS'
export const GET_HRES96U_LABELS = 'GET_HRES96U_LABELS'
export const RECEIVED_HRES96U_COLUMNS_LABELS = 'RECEIVED_HRES96U_COLUMNS_LABELS'
export const SET_HRES96U_INDEX = 'SET_HRES96U_INDEX'
export const GET_HRES96U_INDEX = 'GET_HRES96U_INDEX'
export const RECEIVED_HRES96U_INDEX = 'RECEIVED_HRES96U_INDEX'
export const SET_HRES96U_INDEX_SELECTED = 'SET_HRES96U_INDEX_SELECTED'
export const GET_HRES96U_INDEX_SELECTED = 'GET_HRES96U_INDEX_SELECTED'
export const SET_HRES96U_DETAIL = 'SET_HRES96U_DETAIL'
export const GET_HRES96U_DETAIL = 'GET_HRES96U_DETAIL'
export const RECEIVED_HRES96U_DETAIL = 'RECEIVED_HRES96U_DETAIL'
export const TOGGLE_HRES96U_PAGE = 'TOGGLE_HRES96U_PAGE'
export const POST_HRES96U_SEND_APPROVE = 'POST_HRES96U_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres96u/mutation-types.js